import AxiosConfig from '@/config/axios-config'

export const ModuloAPI = {

  listar () {
    return AxiosConfig.secureJalekoAPI().get('/modulos').then(response => response.data)
  },

  salvar (modulo) {
    return AxiosConfig.secureJalekoAPI().post('/admin/modulos', modulo).then(response => response.data)
  },

  editar (modulo) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/modulos/${modulo.id}`, modulo).then(response => response.data)
  },

  deletar (modulo, cursoId) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/modulos/${modulo.id}`,
      {
        params: {
          cursoId: cursoId
        }
      }).then(response => response.data)
  }

}

export default ModuloAPI
